import { Button, Dialog, DialogContent, DialogTitle } from '@mui/material'
import React from 'react'
import css from './noteDialog.css'

import { i18n } from '../../../index'

type NoteDialogProps = {
  result: any
  isOpen: boolean
  onClose: (...args: Array<any>) => any
}

class NoteDialog extends React.PureComponent<NoteDialogProps> {
  render() {
    const { result, isOpen, onClose } = this.props
    return (
      <Dialog
        /* TODO: Handle this: disableBackdropClick */
        open={isOpen}
        onClose={onClose}
        aria-labelledby='form-dialog-title'
        className={css.component}
      >
        {result === 'error' && (
          <div>
            <DialogTitle id='form-dialog-title'>{i18n.t('admin.chainSettings.error')}</DialogTitle>
            <DialogContent>
              <p>{i18n.t('admin.chainSettings.anErrorOccurred')}</p>
              <Button type='button' variant='contained' color='primary' onClick={() => onClose()}>
                {i18n.t('buttons.close')}
              </Button>
            </DialogContent>
          </div>
        )}
        {result !== 'error' && (
          <div>
            <DialogTitle id='form-dialog-title'>
              {result.length} {i18n.t('admin.chainSettings.xUpdated')}
            </DialogTitle>
            <DialogContent>
              {i18n.t('admin.chainSettings.theFollowingHaveBeenUpdated')}
              <ul>
                {result.map((station, index) => {
                  return <li key={index}>{station}</li>
                })}
              </ul>
              <Button type='button' variant='contained' color='primary' onClick={() => onClose()}>
                {i18n.t('buttons.close')}
              </Button>
            </DialogContent>
          </div>
        )}
      </Dialog>
    )
  }
}

export default NoteDialog
